"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsOpenSource = exports.NetlistValidationOutcome = exports.ParseResolutionAction = exports.ParseFailurePhase = exports.UploadValidationFailureReason = exports.BuildTransitionTrigger = void 0;
var BuildTransitionTrigger;
(function (BuildTransitionTrigger) {
    BuildTransitionTrigger["System"] = "system";
    BuildTransitionTrigger["StaffOverride"] = "staff_override";
    BuildTransitionTrigger["Customer"] = "customer";
})(BuildTransitionTrigger || (exports.BuildTransitionTrigger = BuildTransitionTrigger = {}));
var UploadValidationFailureReason;
(function (UploadValidationFailureReason) {
    UploadValidationFailureReason["Validation"] = "validation";
    UploadValidationFailureReason["Exception"] = "exception";
})(UploadValidationFailureReason || (exports.UploadValidationFailureReason = UploadValidationFailureReason = {}));
var ParseFailurePhase;
(function (ParseFailurePhase) {
    ParseFailurePhase["Parse"] = "parse";
    ParseFailurePhase["Ingest"] = "ingest";
})(ParseFailurePhase || (exports.ParseFailurePhase = ParseFailurePhase = {}));
var ParseResolutionAction;
(function (ParseResolutionAction) {
    ParseResolutionAction["Retried"] = "retried";
    ParseResolutionAction["Bypassed"] = "bypassed";
    ParseResolutionAction["TimedOut"] = "timed_out";
})(ParseResolutionAction || (exports.ParseResolutionAction = ParseResolutionAction = {}));
var NetlistValidationOutcome;
(function (NetlistValidationOutcome) {
    NetlistValidationOutcome["Valid"] = "valid";
    NetlistValidationOutcome["Invalid"] = "invalid";
    NetlistValidationOutcome["NoNetlist"] = "no_netlist";
    NetlistValidationOutcome["Unparseable"] = "unparseable";
})(NetlistValidationOutcome || (exports.NetlistValidationOutcome = NetlistValidationOutcome = {}));
var ResultsOpenSource;
(function (ResultsOpenSource) {
    ResultsOpenSource["DeliveryLink"] = "delivery_link";
    ResultsOpenSource["Direct"] = "direct";
})(ResultsOpenSource || (exports.ResultsOpenSource = ResultsOpenSource = {}));
//# sourceMappingURL=build-lifecycle-enums.js.map